"use strict";
import e from "./index.es169.js";
import s from "./index.es107.js";
import t from "./index.es103.js";
import p from "./index.es105.js";
import a from "./index.es113.js";
import f from "./index.es114.js";
function n(r) {
  if (r.cancelToken && r.cancelToken.throwIfRequested(), r.signal && r.signal.aborted)
    throw new p(null, r);
}
function u(r) {
  return n(r), r.headers = a.from(r.headers), r.data = e.call(
    r,
    r.transformRequest
  ), ["post", "put", "patch"].indexOf(r.method) !== -1 && r.headers.setContentType("application/x-www-form-urlencoded", !1), f.getAdapter(r.adapter || t.adapter, r)(r).then(function(o) {
    return n(r), o.data = e.call(
      r,
      r.transformResponse,
      o
    ), o.headers = a.from(o.headers), o;
  }, function(o) {
    return s(o) || (n(r), o && o.response && (o.response.data = e.call(
      r,
      r.transformResponse,
      o.response
    ), o.response.headers = a.from(o.response.headers))), Promise.reject(o);
  });
}
export {
  u as default
};
//# sourceMappingURL=index.es140.js.map
